module.exports = "pegasus/assets/styleGroup1.png";